import { ArrowBackIcon } from "@l2r-front/l2r-icons"
import { PropTypes } from "@l2r-front/l2r-proptypes"
import { Typography } from "@l2r-front/l2r-ui"

import * as Styled from "./AccountSettingsMobileLayout.styled"

export function AccountSettingsMobileLayout(props) {
    const {
        onBack,
        title,
        children,
    } = props

    return (
        <>
            <Styled.Header>
                <Styled.BackButton onClick={onBack}>
                    <ArrowBackIcon color="common/black_states" />
                </Styled.BackButton>
                <Typography>{title}</Typography>
            </Styled.Header>
            {children}
        </>
    )
}

AccountSettingsMobileLayout.propTypes = {
    onBack: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    children: PropTypes.node,
}